import { Package } from 'lucide-react';
import type { ProductWithMedia } from '../../types/products';
import { ProductCard } from './ProductCard';

interface ProductListProps {
  products: ProductWithMedia[];
  isLoading?: boolean;
}

export function ProductList({ products, isLoading }: ProductListProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="bg-white dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700 overflow-hidden animate-pulse"
          >
            <div className="aspect-square bg-gray-200 dark:bg-slate-600" />
            <div className="p-4 space-y-3">
              <div className="h-3 bg-gray-200 dark:bg-slate-600 rounded w-1/2" />
              <div className="h-4 bg-gray-200 dark:bg-slate-600 rounded w-full" />
              <div className="h-3 bg-gray-200 dark:bg-slate-600 rounded w-1/3" />
              <div className="h-5 bg-gray-200 dark:bg-slate-600 rounded w-1/4" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700 p-12 text-center">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Package className="w-8 h-8 text-primary" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
          Keine Produkte gefunden
        </h3>
        <p className="text-gray-500 dark:text-slate-400">
          Versuche andere Suchbegriffe oder Filter.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
